import { useState } from "react";
import {
  _accept_restaurant_order,
  _ready_restaurant_order,
  _reject_restaurant_order,
} from "../common/axios_services";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../common/utils/notification";
import NumberFormat from "react-number-format";
import { Tag } from "antd";

export const useOrderActions = (refreshOrders, navigate) => {
  const [spinnerLoading, setSpinnerLoading] = useState(false);

  const orderColumns = [
    {
      title: "S/N",
      dataIndex: "sn",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Time",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Customer",
      dataIndex: ["user", "first_name"],
      key: "user_first_name",
    },
    {
      title: "Ref Code",
      dataIndex: "track_id",
      key: "track_id",
      render: (text) => `#${text}`,
    },
    {
      title: "Item",
      dataIndex: "item",
      key: "item_quantity",
      render: (items) =>
        items?.map((item) => item.quantity).reduce((a, b) => a + b, 0),
    },
    {
      title: "Sales",
      dataIndex: "settleAmount",
      key: "sales",
      render: (text) => (
        <NumberFormat
          value={Number(text)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"₦"}
        />
      ),
    },
    {
      title: "Del. Type",
      dataIndex: "delivery_type",
      key: "delivery_type",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let displayStatus;
        if (status?.toLowerCase() === "waiting") {
          displayStatus = "Pending";
        } else if (status?.toLowerCase() === "accepted") {
          displayStatus = "Accepted";
        } else {
          displayStatus = status.charAt(0).toUpperCase() + status.slice(1);
        }

        const tagColor =
          status?.toLowerCase() === "waiting"
            ? "orange"
            : status === "canceled" || status === "rejected"
            ? "red"
            : "green";

        return <Tag color={tagColor}>{displayStatus}</Tag>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <span
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={() => handleViewClick(record)}
        >
          View
        </span>
      ),
    },
  ];
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAcceptModalVisible, setIsAcceptModalVisible] = useState(false);
  const [isReadyModal, setIsReadyModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleViewClick = (record) => {
    setSelectedOrder(record);
    setIsModalVisible(true);
  };

  const handleAcceptOrder = async (willSelfDeliver) => {
    if (!selectedOrder) return;
    try {
      setIsAcceptModalVisible(false);
      setSpinnerLoading(true);
      await _accept_restaurant_order(selectedOrder.id, willSelfDeliver);
      showSuccessNotification("Order accepted successfully!");
      refreshOrders();
    } catch (err) {
      handleApiError(err, navigate);
    } finally {
      setSpinnerLoading(false);
    }
  };

  const handleRejectOrder = async () => {
    if (!selectedOrder) return;
    try {
      setIsModalVisible(false);
      setSpinnerLoading(true);
      await _reject_restaurant_order(selectedOrder.id);
      showSuccessNotification("Order rejected successfully!");
      setIsReadyModal(false);
      refreshOrders();
    } catch (err) {
      handleApiError(err, navigate);
    } finally {
      setSpinnerLoading(false);
    }
  };

  const handleReadyOrder = async (bikerId) => {
    if (!selectedOrder) return;
    try {
      setIsReadyModal(false);
      setSpinnerLoading(true);
      await _ready_restaurant_order(selectedOrder.id, bikerId);
      showSuccessNotification("Order is ready!");
      refreshOrders();
    } catch (err) {
      handleApiError(err, navigate);
    } finally {
      setSpinnerLoading(false);
    }
  };

  return {
    spinnerLoading,
    setSpinnerLoading,
    orderColumns,
    isModalVisible,
    setIsModalVisible,
    isAcceptModalVisible,
    setIsAcceptModalVisible,
    isReadyModal,
    setIsReadyModal,
    selectedOrder,
    handleViewClick,
    handleAcceptOrder,
    handleRejectOrder,
    handleReadyOrder,
  };
};

const handleApiError = (err, navigate) => {
  showErrorNotification(err?.response?.data?.message||err?.message||"An error occurred");
};
